// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__7-5OD","goBackButton":"NotFound_goBackButton__lXxPR"};